import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-vrbo-logman',
    templateUrl: './vrbo-logman.component.html',
    styleUrls: ['./vrbo-logman.component.css'],
    standalone: false
})
export class VRBOLogmanComponent implements OnInit {

  logmanLinks = [
    {
      service: 'Property Sync',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/saveVrboProperty',
      propertyLogmanUrl: 'https://admin.kbmhawaii.com/logmans/short-term-rental/saveVrboProperty/1',
      postmanUrl: 'https://www.kbmhawaii.com/api/2.6/vrbo/v3/createProperty'
    },
    {
      service: 'Booking Create',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/createBooking',
      propertyLogmanUrl: 'https://admin.kbmhawaii.com/logmans/short-term-rental/createBooking/1',
      postmanUrl: 'https://www.kbmhawaii.com/api/2.6/vrbo/bookings/create'
    },
    {
      service: 'Booking Update',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/createBookingContentIndex',
      postmanUrl: 'https://www.kbmhawaii.com/api/2.6/vrbo/bookings/booking-content-index'
    },
    {
      service: 'Booking Confirmation',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/getBookingConfirmationUpdate',
      postmanUrl: 'https://www.kbmhawaii.com/api/2.6/vrbo/bookings/213332-5C4C4E6F'
    },
    {
      service: 'Unit Availability',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/createUnitAvailabilityUpdate',
      propertyLogmanUrl: 'https://admin.kbmhawaii.com/logmans/short-term-rental/createUnitAvailabilityUpdate/1',
      postmanUrl: 'https://www.kbmhawaii.com/api/2.6/vrbo/v3/unit-availability/update/1'
    },
    {
      service: 'Lodging Rate',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/createLodgingRateLosUpdate',
      propertyLogmanUrl: 'https://admin.kbmhawaii.com/logmans/short-term-rental/createLodgingRateLosUpdate/1',
      postmanUrl: 'https://www.kbmhawaii.com/api/2.6/vrbo/v3/lodging-rates/los/1'
    },
    {
      service: 'Fast Availability',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/getFastAvailability',
      propertyLogmanUrl: 'https://admin.kbmhawaii.com/logmans/short-term-rental/getFastAvailability/1',
      postmanUrl: 'https://www.kbmhawaii.com/api/2.6/vrbo/bookings/fast-availability'
    },
    {
      service: 'Messaging',
      propertyLogmanUrl: 'https://admin.kbmhawaii.com/logmans/VRBO_MSG_VO_PROCESSING',
      postmanUrl: 'https://www.kbmhawaii.com/api/2.6/vrbo/v3/callback'
    },
    {
      service: 'Guest Review Submitted',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/vrboReviewReceivedHandler',
      postmanUrl: ''
    },
    {
      service: 'VRBO Review Event',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/VrboReviewEvent',
      postmanUrl: ''
    }
  ];

  constructor(private messageService: MessageService) { }

  ngOnInit(): void {
  }

  openLink(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
  }

}
